import { Container, Heading, Text, VStack, Image } from '@chakra-ui/react';

export const ComingSoon = () => {
  return (
    <Container centerContent>
      <VStack gap="2em" py="5em">
        <Image src="/rocket.svg" width={200} height={200} alt="rocket-icon" />
        <Heading as="h1" size="2xl" textAlign="center">
          Coming Soon!
        </Heading>
        <Text fontSize="lg" textAlign="center">
          We are working hard to bring you this content. Stay tuned for updates!
        </Text>
      </VStack>
    </Container>
  );
};
